import { Component } from '@angular/core';
import { ApiGatewayService, OrganizationSubscription } from 'src/app/services/api-gateway.service';
import { emitInfoMessage, InfoMessageService } from 'src/app/services/info-message.service';
import { fleetPage, formatMoney, orderPages, SubscriptionOrderService } from 'src/app/services/subscription-order.service';

@Component({
    selector: 'tab-subscriptions',
    templateUrl: './tab-subscriptions.component.html',
    standalone: false
})
export class TabSubscriptionsComponent {
  subscriptions: OrganizationSubscription[] = [];
  fleet = false;
  money = formatMoney;
  pages = orderPages;
  fleetPage = fleetPage;
  private now = Date.now();

  constructor(
    private gatewayApiService: ApiGatewayService,
    private infoMessageService: InfoMessageService,
    public order: SubscriptionOrderService,
  ) {
    this.getSubscriptions();
    this.getPrices();
  }

  async getSubscriptions() {
    try {
      this.subscriptions = (await this.gatewayApiService.getSubscriptions()).body ?? [];
    } catch (error: any) {
      emitInfoMessage("Could not get subscriptions: " + error?.message, this.infoMessageService);
    }
  }

  async getPrices() {
    try {
      const profile = await this.gatewayApiService.getUserProfile();
      this.fleet = profile.body?.organization?.subscription_mode === 'SUBSCRIPTION';
      if (!this.fleet) {
        await this.order.loadPriceList();
      }
    } catch (error: any) {
      emitInfoMessage("Could not get prices: " + error?.message, this.infoMessageService);
    }
  }

  get current(): OrganizationSubscription[] {
    return this.subscriptions
      .filter(s => this.now < new Date(s.ends_at).getTime())
      .sort((a, b) => a.ends_at.localeCompare(b.ends_at));
  }

  places(subscription: OrganizationSubscription): string {
    return subscription.capacity_devices === 0 ? 'Unlimited' : String(subscription.capacity_devices);
  }

  term(subscription: OrganizationSubscription): string {
    const starts = new Date(subscription.starts_at).getTime() > this.now;
    return (starts ? 'starts in ' : 'ends in ') + this.until(starts ? subscription.starts_at : subscription.ends_at);
  }

  private until(date: string): string {
    const end = new Date(date);
    const now = new Date(this.now);
    const months = (end.getUTCFullYear() - now.getUTCFullYear()) * 12 + end.getUTCMonth() - now.getUTCMonth()
      - (end.getUTCDate() < now.getUTCDate() ? 1 : 0);
    if (months > 0) {
      return months === 1 ? '1 month' : `${months} months`;
    }
    const days = Math.ceil((end.getTime() - this.now) / 86_400_000);
    return days === 1 ? '1 day' : `${days} days`;
  }

  buyMore() {}
}
